import { render, staticRenderFns } from "./reportele.vue?vue&type=template&id=961b8eaa&scoped=true&"
import script from "./reportele.vue?vue&type=script&lang=js&"
export * from "./reportele.vue?vue&type=script&lang=js&"
import style0 from "./reportele.vue?vue&type=style&index=0&id=961b8eaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961b8eaa",
  null
  
)

export default component.exports